import { render, staticRenderFns } from "./AddressFormItem.vue?vue&type=template&id=43ef907a&scoped=true"
import script from "./AddressFormItem.vue?vue&type=script&lang=js"
export * from "./AddressFormItem.vue?vue&type=script&lang=js"
import style0 from "./AddressFormItem.vue?vue&type=style&index=0&id=43ef907a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ef907a",
  null
  
)

export default component.exports